export const messagesConstants = {
    LOADING: "LOADING",
    RESPONSE_STATE: "RESPONSE_STATE",
    GET_CONVERSATIONS: "GET_CONVERSATIONS",
    GET_MESSAGES: "GET_MESSAGES",
    GET_MESSAGES_UNREAD_TOTAL: "GET_MESSAGES_UNREAD_TOTAL",
    GET_MESSAGE_DETAILED: "GET_MESSAGE_DETAILED",
    GET_USERS_FOR_CHAT: "GET_USERS_FOR_CHAT",
}